import React from 'react';


import {  Input,  Space } from 'antd';

import { getAsNumber } from '../../../../../../utilities/numberConvertion';
import AttachmentModal from '../../../../../../components/Modal/AttachmentModal';



export const TableCol = (action, semesterKey, status) => {

  return [
    {
      key: 'number_of_sessions',
      dataIndex: 'number_of_sessions',
      title: 'Number of sessions',
      render: (value, row) => (
        <Input
          style={{maxWidth:'500px'}}
          placeholder="Enter"
          value={value}
          onChange={(e) => action({ ...row, number_of_sessions: getAsNumber(e.target.value) })}
          disabled={status === 1 || status === 2 || status === 3}
        />
      )
    },
    {
      key: 'modal',
      dataIndex: 'modal',
      title: 'Attachments(Require dept. approval)',
      render: (value, row) => {
  
        const title = `${semesterKey === 1 ? 'Spring' : semesterKey === 2 ? 'Summer' : semesterKey === 3 ? 'Autumn' : '' } - Number of sessions`;
    
        return (
          <Space>
            <AttachmentModal
              row={row}
              action={action}
              parentKey="modal"
              title={title}
              disabled={status === 1 || status === 2 || status === 3}
              status={status}
              isMandatory={false}
            />
          </Space>
        );
      }
    },
  ]
}
